/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import {
  Box, Paper, Tabs, Tab, Typography,
  ToggleButtonGroup, ToggleButton, CircularProgress,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import client from '../../lib/api/client';
import KpiReportChart from '../../components/targetmng/KpiReportChart';
import KpiReportTable from '../../components/targetmng/KpiReportTable';

// 탭별 목표 유형 — StatsTargetController targetTyp 값과 동일하게
const TARGET_TABS = [
  { value: 'SALES',      label: '영업' },
  { value: 'PRODUCTION', label: '생산' },
  { value: 'QC',         label: '품질' },
  { value: 'TECH',       label: '기술' },
];

const KpiReportContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const currentYear = new Date().getFullYear();

  const [tabIndex, setTabIndex]   = useState(0);
  const [viewMode, setViewMode]   = useState('monthly'); // monthly | yearly
  const [loading, setLoading]     = useState(false);

  // 당년 + 전년 2개년 고정
  const years = useMemo(() => [currentYear, currentYear - 1], []);

  // 데이터: { [year]: list[] }
  const [reportData, setReportData] = useState({});

  const targetTyp = TARGET_TABS[tabIndex].value;

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // StatsTargetController: GET /api/v1/statistics/target/expect/headQuarter/{targetTyp}/{year}/{strtMonth}/{endMonth}
      // 본부별 집계를 당년/전년 각각 조회
      const results = await Promise.all(
        years.map((year) =>
          client.get(
            `/api/v1/statistics/target/expect/headQuarter/${targetTyp}/${year}/1/12`
          )
            .then((res) => ({ year, list: res.data?.list || [] }))
            .catch(() => ({ year, list: [] }))
        )
      );
      const map = {};
      results.forEach(({ year, list }) => { map[year] = list; });
      setReportData(map);
    } catch (e) {
      enqueueSnackbar('데이터 조회 실패', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [targetTyp]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Box sx={{ mt: 2 }}>
      {/* 탭 */}
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tabIndex}
          onChange={(_, v) => setTabIndex(v)}
          sx={{ px: 2 }}
        >
          {TARGET_TABS.map((t) => (
            <Tab key={t.value} label={t.label} />
          ))}
        </Tabs>
      </Paper>

      {/* 뷰 전환 */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          {currentYear}년 · {currentYear - 1}년 비교
        </Typography>
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          size="small"
          onChange={(_, v) => v && setViewMode(v)}
        >
          <ToggleButton value="monthly">월별</ToggleButton>
          <ToggleButton value="yearly">연도별</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <KpiReportChart
            targetTyp={targetTyp}
            years={years}
            reportData={reportData}
            viewMode={viewMode}
          />
          <KpiReportTable
            targetTyp={targetTyp}
            years={years}
            reportData={reportData}
            viewMode={viewMode}
          />
        </>
      )}
    </Box>
  );
};

export default KpiReportContainer;
